import { gql } from '@apollo/client'

export const CREATE_DRIVE_TRAIN = gql`
  mutation createDriveTrain($input: CreateDriveTrainInput!) {
    data: createDriveTrain(input: $input) {
      id
    }
  }
`
